import { useCallback } from 'react';
import { history } from '@umijs/max';
import { setAppName } from '@/utils/app-cache';

const scheduleCacheWrite = (cacheKey: string, tabTitle: string) => {
  const write = () => setAppName(cacheKey, tabTitle);
  // Avoid blocking the message event handler with sync localStorage work.
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    (window as any).requestIdleCallback(write, { timeout: 300 });
    return;
  }
  setTimeout(write, 0);
};

export default () => {
  const handleMessage = useCallback((msg: any) => {
    if (!msg || msg.type !== 'navigate') return;
    const { href, tabTitle, cacheKey } = msg.data || {};
    if (!href) return;

    // 缓存 tab 标题（用于刷新后恢复）
    if (cacheKey && tabTitle) {
      scheduleCacheWrite(cacheKey, tabTitle);
    }
    history.push(href, tabTitle ? { tabTitle } : undefined);
  }, []);
  return {
    handleMessage,
  };
};
